import { render, staticRenderFns } from "./albertactionreport.vue?vue&type=template&id=f79623a2&"
import script from "./albertactionreport.vue?vue&type=script&lang=js&"
export * from "./albertactionreport.vue?vue&type=script&lang=js&"
import style0 from "./albertactionreport.vue?vue&type=style&index=0&id=f79623a2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79623a2')) {
      api.createRecord('f79623a2', component.options)
    } else {
      api.reload('f79623a2', component.options)
    }
    module.hot.accept("./albertactionreport.vue?vue&type=template&id=f79623a2&", function () {
      api.rerender('f79623a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionreport.vue"
export default component.exports